import { render, staticRenderFns } from "./newNoticeBtn.vue?vue&type=template&id=442f02b5&scoped=true&"
import script from "./newNoticeBtn.vue?vue&type=script&lang=js&"
export * from "./newNoticeBtn.vue?vue&type=script&lang=js&"
import style0 from "./newNoticeBtn.vue?vue&type=style&index=0&id=442f02b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442f02b5",
  null
  
)

export default component.exports